<template>
  <div class="login">
    <div class="login-card">
      <div class="card-title">
        <h1>FaibaMkononi Login</h1>
      </div>
      <div class="content">
        <form @submit.prevent="onSubmit">
          <div class="field">
            <label class="label">Username</label>
            <div class="control has-icons-left">
              <input v-model="userInfo.username" class="input" name="username" type="text" required>
              <span class="icon is-small is-left">
                <font-awesome-icon icon="user"/>
              </span>
            </div>
            <p class="help is-success not-shown">This username is available</p>
          </div>
          <div class="field">
            <label class="label">Password</label>
            <div class="control has-icons-left">
              <input
                v-model="userInfo.password"
                class="input"
                name="password"
                type="password"
                required
              >
              <span class="icon is-small is-left">
                <font-awesome-icon icon="lock"/>
              </span>
            </div>
            <p class="help is-success not-shown">Password Is invalid</p>
          </div>
          <div class="sub_btn_container">
            <div class="control">
              <button
                id="submit"
                type="submit"
                class="button is-primary"
                :class="{'is-loading':isLoading}"
              >Login</button>
            </div>
          </div>
          <div class="level">
            <div class="level-middle">
              <div class="level-item">
                <!-- <p class="is-success">Dont have an Account yet ?</p> -->
              </div>
            </div>
            <div class="level-right tosignup">
              <div class="level-item">
                <div class="control">
                  <button
                    @click="toSignUp"
                    id="signup"
                    type="button"
                    class="button is-light"
                  >Create New Account</button>
                </div>
              </div>
            </div>
            <div class="level-left toforgot is-hidden">
              <div class="level-item">
                <div class="control">
                  <button
                      @click="toForgotPass"
                      id="forgot_pass"
                      type="button"
                      class="button is-light is-small"
                  >Forgot Password ?</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="card-footer" style="justify-content: center;">
        <p class="contact">Call Us @ 0746 627 355</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import alertify from "alertifyjs";
import { dataFromDom } from "@/lib/utils";
import { mapActions, mapState } from "vuex";
import { setInterval, setTimeout } from "timers";

export default {
  data: function() {
    return {
      userInfo: {
        username: "",
        password: ""
      },
      isLoading: false
    };
  },
  created: function() {
    var self = this;
    alertify.set("notifier", "position", "top-center");
    this.getUser().then(() => {
      setTimeout(() => {
        if (this.serverAuth) {
          // this.$router.push('/account')
          if (!this.routerAuth) {
            //this.routerLogin();
            this.kickAccount()
          }
          //console.log('already logged')
          this.$router.push("/account");
        }
      }, 100);
    });
  },
  methods: {
    ...mapActions(["getUser", "routerLogin","kickAccount"]),
    onSubmit() {
      this.isLoading = true;
      var self = this;
      axios
        .post("/api/client/login", this.userInfo)
        .then(response => {
          var body = response.data;
          if (body.success) {
            //server success
            this.$store.commit("serverAuth", true);
            this.$store.commit("setSessionId",body.sessionId)
            //populate user
            this.getUser();
            axios
              .get("http://100.0.0.1/login")
              .then(function(response) {
                var body = dataFromDom(response.data);
                if (body.router) {
                  axios
                    .post(
                      "/api/client/setLocation",
                      { userId: self.user._id, routerName: body.router }
                    )
                    .then(function(response) {
                      var body = response.data;
                      if (body.success) {
                        self.user.lastLoginLocation = body.location;
                      }
                    })
                    .catch(function(error) {
                      console.log(error);
                    });
                }
              })
              .catch(function(error) {
                console.log(error);
              });
            if (body.proceed) {
              //proceed to router
              axios
                .post(
                  "http://100.0.0.1/login",
                  `username=${this.userInfo.username.trim()}&password=${
                    this.userInfo.password
                  }`,
                  {
                    headers: {
                      "Content-Type": "application/x-www-form-urlencoded"
                    }
                  }
                )
                .then(response => {
                  this.isLoading = false;
                  var session = dataFromDom(response.data);
                  if (session.title === "login") {
                    //login not successful
                    this.$router.push("/account");
                    alertify
                      .alert()
                      .setting({
                        transition: "zoom",
                        closableByDimmer: false,
                        title: "Notification",
                        label: "Ok",
                        message:
                          "You cannot access the Internet <br> <b> Reason: <b/> <br>" +
                          session.error,
                        onok: function() {
                          self.$router.push("/account");
                        }
                      })
                      .show();
                  } else if (session.title === "alogin") {
                    //login success
                    this.$store.commit("routerAuth", true);
                    this.$router.push("/account");
                  }
                })
                .catch(error => {
                  console.log(error);
                  alertify.alert(
                    "Error Occured",
                    "Internal Server Error Contact admin"
                  );
                });
            } else {
              this.isLoading = false;
              //dont try logging in to router
              alertify
                .alert()
                .setting({
                  transition: "zoom",
                  closableByDimmer: false,
                  title: "Notification",
                  label: "Ok",
                  message:
                    "You cannot access the Internet <br> <b> Reason: <b/> <br>" +
                    body.messages,
                  onok: function() {
                    self.$router.push("/account");
                  }
                })
                .show();
            }
          } else {
            alertify.error(body.messages["message"]);
            this.isLoading = false;
          }
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error);
          alertify.alert(
            "Error Occured",
            "Internal Server Error Contact admin"
          );
        });
    },
    toSignUp() {
      this.$router.push("/signup");
    },
    toForgotPass(){
      this.$router.push('/PasswordRecovery')
    }
  },
  computed: {
    loginStatus() {
      setInterval(() => {
        console.log(this.$store.getters.isLoggedIn);
      }, 200);
      return this.$store.getters.isLoggedIn;
    },
    ...mapState(["user", "serverAuth", "routerAuth", "sessionId"])
  }
};
</script>

<style scoped>
.login {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #f7f7f7;
}
.login-card {
  margin-top: auto;
  margin-bottom: auto;
  background: #fff;
  width: 35rem;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11);
}
.card-title {
  background-color: #00b89c;
  padding: 1em;
}
.card-title h1 {
  color: #fff;
  text-align: center;
  font-size: 1.2rem;
}
.content {
  padding: 3rem 2.5rem 5rem;
}

.not-shown {
  visibility: hidden;
}
.card {
  background: #fff;
  width: 24rem;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11);
  padding: 3rem 2.5rem 5rem;
}

.sub_btn_container {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
#submit {
  width: 100%;
}
.submit{
  width: 100%;
}
.contact{
  display: flex;
  justify-content: center;
  font-weight: 700;
}


input:focus {
  box-shadow: none;
  border-color: #00d1b2;
}
@media (max-width: 768px) {
  .tosignup {
    position: relative;
    right: 4.7rem;
  }
  .toforgot{
    position: relative;
    left: 4.8rem;
    top: -1.7rem;
  }
}
/*
input {
  border: none;
  box-shadow: none;
  border: none;
  border-bottom: 1px solid #dbdbdb;
  border-radius: 0px;
}

input:focus {
  box-shadow: none;
  border-color: #00d1b2;
}*/
</style>
